/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Start_Chat_New_Project_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter project name" |
*
* @param {Form_Start_Chat_New_Project_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_start_chat_new_project_name_placeholder = /** @type {((inputs?: Form_Start_Chat_New_Project_Name_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Start_Chat_New_Project_Name_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gib den Projektnamen ein")
	return /** @type {LocalizedString} */ ("Enter project name")
});